import * as classNames from 'classnames'
import * as React from 'react'

interface IEntitiesTopPanelProps {
  children?: any
  className?: string
}

interface IEntitiesTopPanelItemProps {
  children?: any
  active?: boolean
}

const EntitiesTopPanel = (props: IEntitiesTopPanelProps) => (
  <div className={`col-12 px2 border-box ${props.className}`}>{props.children}</div>
)

const EntitiesTopPanelItem = ({ children, active = false }: IEntitiesTopPanelItemProps) => {
  const style = classNames(
    'flex items-center py1 mr3 bb-width-2',
    { 'bb-green bold font-blue-grey h2': active },
    { 'bb-transparent font-light-grey4 h4': !active }
  )

  return (
    <div className={style} style={{ marginBottom: -1 }}>
      {children}
    </div>
  )
}

export { EntitiesTopPanelItem }
export default EntitiesTopPanel



// WEBPACK FOOTER //
// ./src/components/ui/EntitiesTopPanel.tsx